<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.ysy">
      </p>
      <p>
        <br>
      </p>
      <p>
        <span style="font-size:18px;font-family:宋体;">
          <strong>氨基葡萄糖盐酸盐</strong>
        </span>
      </p>
      <p>
        <u>
          <span style="font-size:12px;font-family:Arial;">Commodity</span>
        </u>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">:</span>
          <span style="font-size:12px;">&nbsp;</span>
          <span style="font-size:12px;">Clucosamine HCL</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
      </p>
      <p>
        <u>
          <span style="font-size:12.0pt;font-family:Arial;">
            <span style="text-decoration:none;">
              <br>
            </span>
          </span>
        </u>
      </p>
      <p>
        <u>
          <span style="font-size:12px;font-family:Arial;">Spec:</span>
        </u>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">&nbsp;&nbsp;</span>
          <span style="font-size:12px;">&nbsp;</span>
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          Content: &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          ≥99%
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          Appearance
          (Visual): White Crystalline Powder
        </span>
      </p>
      <p style="text-align:left;" align="left">
        <span
          style="font-size:12px;font-family:Arial;"
        >Loss on Drying :&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &lt; 0.3%</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            PH&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            3.0 - 5.6 (5% solution)
          </span>
          <br>
          <span style="font-size:12px;">Residue on Ignition:&nbsp;&nbsp; &lt; 0.3%</span>
          <br>
          <span
            style="font-size:12px;"
          >Chloride:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &lt; 17%</span>
          <br>
          <span style="font-size:12px;">Specific Rotation:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; +70°-- 74°</span>
          <br>
          <span
            style="font-size:12px;"
          >Total Plate Count:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &lt; 3000 cfu/g</span>
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          Heavy
          Metals:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &lt;10ppm
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            Arsenic:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            &lt; 2 ppm
          </span>
          <br>
          <span
            style="font-size:12px;"
          >Yeast and Molds:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &lt;100ct/g</span>
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          Escherichia
          coil:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Absent
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          Salmonalla
          species: Absent
        </span>
      </p>
      <p>
        <span
          style="font-size:12px;font-family:Arial;"
        >Particle Size:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 100% thru 80 mesh</span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          Lead
          :&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &lt; 0.5ppm
        </span>
      </p>
      <p>
        <u>
          <span style="font-size:12.0pt;font-family:Arial;">
            <span style="text-decoration:none;">
              <br>
            </span>
          </span>
        </u>
      </p>
      <p>
        <u>
          <span style="font-size:12px;font-family:Arial;">Packing</span>
        </u>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">: 25kg per drum</span>
          <span></span>
        </span>
      </p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        ysy: require("../../../assets/img/common/ysy.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/product/ysy.vue